<template>
  <div v-if="$route.path !== '/login'">
    <b-navbar
      toggleable="lg"
      class="
        bottom-border-navbar
        align-items-lg-center container-p-x
      "
      style="background: white;"
    >
      <!-- Brand -->
      <b-navbar-brand>
        <img src="/images/oversea_logos/LogoOversea.jpg" height="50"
      /></b-navbar-brand>

      <!-- Sidenav toggle -->
      <b-navbar-nav
        class="align-items-lg-center mr-auto mr-lg-4"
        v-if="sidenavToggle"
      >
        <a
          class="nav-item nav-link px-0 ml-2 ml-lg-0 hamburguesa"
          href="javascript:void(0)"
          @click="toggleSidenav"
        >
          <i class="ion ion-md-menu text-large align-middle" />
        </a>
      </b-navbar-nav>

      <!-- Navbar toggle -->
      <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

      <b-collapse is-nav id="app-layout-navbar">
        <b-navbar-nav
          class="sidenav-link align-items-lg-center barra__navegacion"
        >
          <b-nav-item class="usuario"
            >{{ afterLoginMenu.UsuarioConectado }}:
            <strong>{{ nombre }}</strong></b-nav-item
          >
          <b-nav-item class="cerrar__sesion" @click="cerrarSesion">{{
            afterLoginMenu.CerrarSesion
          }}</b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="align-items-lg-center ml-auto barra__navegacion">
          <b-nav-item v-if="language == 'es'">{{ date }}</b-nav-item>
          <b-nav-item v-else>{{ dateEng }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
      <!-- Idiomas -->
      <div class="d-flex" style="cursor: pointer; float: right;">
        <!-- Carga de las banderas en función de los idiomas disponibles, recibidos desde la bbdd -->
        <span
          v-for="flag in banderas"
          :key="flag.id"
          @click="bandera(flag.languageCode)"
          ><img :src="flag.image" height="15" class="mr-1 mb-2" />
        </span>
      </div>
    </b-navbar>
  </div>
</template>
<style>
.nav-link {
  color: black !important;
}
.hamburguesa:hover {
  color: rgba(127, 133, 219, 0.5) !important;
  cursor: pointer;
}
.cerrar__sesion > .nav-link:hover {
  color: rgba(127, 133, 219, 0.5) !important;
  cursor: pointer;
}
.nav-link {
  cursor: default;
}
/* botón de usuario */
.navbar-light .navbar-toggler-icon {
  background-image: url("/images/oversea_logos/user.png") !important;
  width: 2.5rem;
  height: 2.5rem;
}
.navbar-light .navbar-toggler {
  border: none;
}
/* borde inferior del navbar */
.bottom-border-navbar {
  border-radius: 0 !important;
  border-color: transparent !important;
  -webkit-box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.2) !important;
  -moz-box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.2) !important;
}
</style>
<script>
// Importación de funciones que guardan el JSON de idioma en localStorage
import {
  saveLanguages,
  getLanguageData
} from "../utilidades/setLanguageJSONLocalStorage.js";
// Importación de función que recoge la info o bien de sessionStorage o de localStorage
import { getFromStorage } from "../utilidades/storage.js";
import axios from "axios";

export default {
  name: "app-layout-navbar",
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    },
    date: {
      type: String
    },
    dateEng: {
      type: String
    }
  },
  data() {
    return {
      isLoading: true,
      banderas: [],
      language: null,
      afterLoginMenu: {},
      nombre: ""
    };
  },
  methods: {
    // función que recibe el nombre de la bandera en la que se hizo click y
    // lo guarda como nuevo lenguaje en localstorage. Después se hace post a la bbdd
    // y se guardan los datos del nuevo idioma seleccionado en localStorage.
    bandera(index) {
      localStorage.setItem("language", index);
      this.isLoading = true;
      const token = getFromStorage("token");
      this.language = getFromStorage("language");
      let config = {
        headers: {
          Authorization: "Bearer " + token,
          "Accept-Language": this.language
        }
      };
      axios
        .get("https://apioversea.siliconvalleyvigo.com/l10n/menu", config)
        .then(response => {
          console.log(
            "afterLoginMenu al pulsar una bandera desde la navbar",
            response
          );
          saveLanguages(response.data.idiomaPantallas);
          this.afterLoginMenu = getLanguageData("afterLogin", this.language);
          // se emite evento para que sea escuchado el cambio de idioma
          this.$emit("lang", this.language);
          this.isLoading = false;
        });
    },
    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },
    getLayoutNavbarBg() {
      return this.layoutNavbarBg;
    },
    cerrarSesion() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push({
        path: "/login"
      });
    }
  },
  created() {
    // se trae el idioma, el nombre del usuario y los textos de la navbar desde localStorage
    this.nombre = getFromStorage("name");
    this.banderas = JSON.parse(getFromStorage("flags"));
    this.language = getFromStorage("language");
    this.afterLoginMenu = getLanguageData("afterLogin", this.language);
    this.isLoading = false;
  }
};
</script>
